goog.provide("shadow.js.shim.module$ol$layer$Vector$default");
shadow.js.shim.module$ol$layer$Vector$default = shadow.js.require(215, {}).default;
